//@flow
import * as regularExpressions from "./RegularExpressions";
import * as colors from "./Colors";
import * as dimensions from "./Dimensions";
import { DeviceType } from "./DeviceType";
export { regularExpressions, colors, dimensions, DeviceType };
